import React from "react";
import "./Footer.css";
import { FaWhatsapp, FaTiktok, FaPhoneAlt, FaInstagram } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="footer-root-footer">
      <div className="footer-container-footer">
        {/* TOP INFO ROW */}
        <div className="footer-top-footer">
          <div className="info-footer">
            <span className="icon-footer" aria-hidden="true">
              {/* location */}
              <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M12 22s8-7.14 8-12a8 8 0 10-16 0c0 4.86 8 12 8 12z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
            </span>
            <div>
              <h4>Cassablanca</h4>
              <p>Dekon , Baguida</p>
            </div>
          </div>

          <div className="info-footer">
            <span className="icon-footer" aria-hidden="true">
              {/* phone */}
              <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.13.98.38 1.93.72 2.84a2 2 0 01-.45 2.11L8 9a16 16 0 006 6l.33-.35a2 2 0 012.11-.45c.91.34 1.86.59 2.84.72A2 2 0 0122 16.92z"></path>
              </svg>
            </span>
            <div>
              <h4>+228 90 04 59 26</h4>
              <p></p>
            </div>
          </div>

          <div className="info-footer">
            <span className="icon-footer" aria-hidden="true">
              {/* clock */}
              <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.5">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M12 6v6l4 2"></path>
              </svg>
            </span>
            <div>
              <h4>Lundi - Dimanche</h4>
              <p></p>
            </div>
          </div>

          <div className="info-footer">
            <span className="icon-footer" aria-hidden="true">
              {/* mail */}
              <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M4 4h16a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2z"></path>
                <path d="M22 6l-10 7L2 6"></path>
              </svg>
            </span>
            <div>
              <h4>dollarstoretogo@gmail.com</h4>
              <p></p>
            </div>
          </div>
        </div>

        <hr className="rule-footer" />

        {/* MAIN GRID */}
        <div className="footer-main-footer">
          {/* About */}
          <div className="about-footer">
            <h2 className="logo-footer">DOLLAR STORE</h2>
            <p>
              Goûtez l’Amérique sans voyager : produits originaux made in USA, disponibles au Togo
            </p>

            <div className="socials-footer" aria-label="Social links">
                <a href="https://wa.me/22890045926" aria-label="WhatsApp" target="_blank" rel="noopener noreferrer">
                  <FaWhatsapp size={20} />
                </a>

                <a href="tel:+22890045926" aria-label="Téléphone">
                  <FaPhoneAlt size={20} />
                </a>

                <a href="https://www.instagram.com/" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                  <FaInstagram size={20} />
                </a>

                <a href="https://www.tiktok.com/@dollarstore_lome" aria-label="TikTok" target="_blank" rel="noopener noreferrer">
                  <FaTiktok size={20} />
                </a>
              </div>
          </div>

          {/* Quick Links */}
          <div className="links-footer">
            <h4>Liens Rapides</h4>
            <ul>
              <li><a href="/">Acceuil</a></li>
              <li><a href="products">Nos Produits</a></li>
              <li><a href="promotions">En Promotion</a></li>
              <li><a href="about">Qui sommes nous?</a></li>
            </ul>
          </div>

          {/* Categories */}
          <div className="links-footer">
            <h4>Parametres</h4>
            <ul>
              <li>Mes commandes</li>
              <li>Mon compte</li>
              <li>Panier</li>
              <li>Support</li>
            </ul>
          </div>

          {/* Newsletter */}
          <div className="newsletter-footer">
            <h4>Visitez nous</h4>
            <p>
              Nos heures d'ourverture: <br />
              <br /> <strong>Lundi - Samedi (08h00 à 21h00) </strong> <br />
              <strong>Dimanche (11h00 à 20h00) </strong>
            </p>
            
          </div>
        </div>

        <hr className="rule-footer" />

        {/* BOTTOM LINE */}
        <div className="footer-bottom-footer">
          <p>
            © {new Date().getFullYear()} <strong>DOLLAR STORE</strong>. All rights reserved.
          </p>

        </div>
      </div>
    </footer>
  );
}
